module.exports = __webpack_public_path__ + "static/img/40001 (2).4206feb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40001 (2).webp
// module id = b6qx
// module chunks = 14